import { memo, useState } from "react";
import styled from "styled-components";
import { Input, Tooltip } from "antd";
import { IoEllipsisHorizontal } from "react-icons/io5";
import { UI_Header, UI_HeaderLeft, UI_HeaderRight, UI_HeaderRight_item } from "~/components/Map/panels/PanelStyle";
import { FaXmark } from "react-icons/fa6";
import { Icon, Shapes } from "./svg/shapes";

export interface IconPanelProps {
  onClose: () => void;
  onIconSelect: (icon: string) => void;
}
const IconPanel = (props: IconPanelProps) => {
  const [keyword, setKeyword] = useState('');
  const shapeKeys = ['dot', 'square', 'diamond', 'triangle', 'x', 'plus', 'slash', 'star', 'heart', 'hexagon', 'octagon'];
  const activitiesAndPlacesKeys = ['person', 'restroom', 'house', 'work', 'letter', 'hotel', 'factory', 'hospital', 'regilious_facility', 'school', 'government', 'university', 'bank', 'landmark', 'mesium', 'clothing', 'shopping', 'store', 'bar', 'pub', 'cafe', 'food', 'park', 'amusement_park', 'camping_tent', 'cabin', 'picnic', 'water_refill', 'trail_head', 'guide_post', 'viewpoint', 'camera', 'us_football', 'football', 'tennis', 'binoculars', 'swimming'];
  const transportationKeys = ['pedestrian', 'bicycle', 'wheelchair', 'airport', 'car', 'bus', 'train', 'truck', 'ferry', 'sailboat', 'electric_service', 'gas_service', 'blood_clinic', 'badge', 'traffic_light', 'traffic_cone', 'road_sign_caution'];
  const infrastructureKeys = ['zap', 'battery_full', 'battery_half', 'battery_low', 'boom', 'radar', 'wind_turbine', 'solar_panel', 'antenna', 'telephone_pole', 'oil_well', 'oil_barrel', 'railroad_track', 'bridge', 'lighthouse', 'lock_closed', 'lock_open', 'wifi', 'trash', 'recycle'];
  const natureKeys = ['tree', 'flower', 'leaf', 'fire', 'mountain', 'snowy_mountain', 'volcano', 'island', 'wave', 'hotsprings', 'water', 'lake', 'ocean', 'animal', 'bird', 'duck', 'dog', 'fish', 'beach', 'wetland'];
  const weatherKeys = ['sun', 'moon', 'cloud', 'partial_sun', 'rain', 'lightning', 'snowflake', 'wind', 'snow', 'fog', 'sleet', 'hurricane'];
  const signsKeys = ['warning', 'character_p', 'info', 'exclamation_point'];
  return <UI_Wrapper>
    {/* Header */}
    <UI_Header>
      <UI_HeaderLeft>Chọn Icon</UI_HeaderLeft>
      <UI_HeaderRight>
        <UI_HeaderRight_item onClick={() => {
          props.onClose();
        }}>
          <FaXmark />
        </UI_HeaderRight_item>
      </UI_HeaderRight>
    </UI_Header>
    {/* End Header */}


    {/* Content */}
    <UI_Content>
      <Input placeholder="Tìm kiếm" value={keyword} onChange={(e) => setKeyword(e.target.value)} />
      <UI_IconGroupList>
        <UI_IconGroup>
          <UI_IconGroup_Header>
            Hình dạng
          </UI_IconGroup_Header>
          <UI_IconGroup_Items>
            {
              shapeKeys.map((key) => {
                return <Tooltip title={key}><UI_Item key={key} onClick={() => {
                  props.onIconSelect(key);
                }}>
                  <Icon icon={key} size={18} />
                </UI_Item></Tooltip>
              })
            }
          </UI_IconGroup_Items>
        </UI_IconGroup>
        <UI_IconGroup>
          <UI_IconGroup_Header>
            Giao thông
          </UI_IconGroup_Header>
          <UI_IconGroup_Items>
            {
              transportationKeys.map((key) => {
                return <Tooltip title={key}><UI_Item key={key} onClick={() => {
                  props.onIconSelect(key);
                }} >
                  <Icon icon={key} size={18} />
                </UI_Item></Tooltip>
              })
            }
          </UI_IconGroup_Items>
        </UI_IconGroup>
        <UI_IconGroup>
          <UI_IconGroup_Header>
            Hoạt động và nơi chốn
          </UI_IconGroup_Header>
          <UI_IconGroup_Items>
            {
              activitiesAndPlacesKeys.map((key) => {
                return <Tooltip title={key}><UI_Item key={key} onClick={() => {
                  props.onIconSelect(key);
                }} >
                  <Icon icon={key} size={18} />
                </UI_Item></Tooltip>
              })
            }
          </UI_IconGroup_Items>
        </UI_IconGroup>
        <UI_IconGroup>
          <UI_IconGroup_Header>
            Cơ sở hạ tầng
          </UI_IconGroup_Header>
          <UI_IconGroup_Items>
            {
              infrastructureKeys.map((key) => {
                return <Tooltip title={key}><UI_Item key={key} onClick={() => {
                  props.onIconSelect(key);
                }} >
                  <Icon icon={key} size={18} />
                </UI_Item></Tooltip>
              })
            }
          </UI_IconGroup_Items>
        </UI_IconGroup>
        <UI_IconGroup>
          <UI_IconGroup_Header>
            Tự nhiên
          </UI_IconGroup_Header>
          <UI_IconGroup_Items>
            {
              natureKeys.map((key) => {
                return <Tooltip title={key}><UI_Item key={key} onClick={() => {
                  props.onIconSelect(key);
                }} >
                  <Icon icon={key} size={18} />
                </UI_Item></Tooltip>
              })
            }
          </UI_IconGroup_Items>
        </UI_IconGroup>
        <UI_IconGroup>
          <UI_IconGroup_Header>
            Thời tiết
          </UI_IconGroup_Header>
          <UI_IconGroup_Items>
            {
              weatherKeys.map((key) => {
                return <Tooltip title={key}><UI_Item key={key} onClick={() => {
                  props.onIconSelect(key);
                }} >
                  <Icon icon={key} size={18} />
                </UI_Item></Tooltip>
              })
            }
          </UI_IconGroup_Items>
        </UI_IconGroup>
        <UI_IconGroup>
          <UI_IconGroup_Header>
            Ký hiệu
          </UI_IconGroup_Header>
          <UI_IconGroup_Items>
            {
              signsKeys.map((key) => {
                return <Tooltip title={key}><UI_Item key={key} onClick={() => {
                  props.onIconSelect(key);
                }} >
                  <Icon icon={key} size={18} />
                </UI_Item></Tooltip>
              })
            }
          </UI_IconGroup_Items>
        </UI_IconGroup>
      </UI_IconGroupList>

    </UI_Content>
    {/* End Content */}
  </UI_Wrapper>
}

export default memo(IconPanel);


const UI_Wrapper = styled.div`
  width: 300px;
  height: 500px;
  border-radius: 8px;
  background-color: rgba(255,255,255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: var(--shadows-paneShadow);
`;

const UI_Content = styled.div`
  padding: 16px;
  height: calc(100% - 64px);
`;

const UI_Toolbar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const UI_ToolbarItem = styled.div`
  cursor: pointer;
  padding: 4px;
`

const UI_Toolbar_Left = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

const UI_Toolbar_Right = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

const UI_IconGroupList = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
`
const UI_IconGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

const UI_IconGroup_Header = styled.div`
  font-size: 12px;
  padding-top: 8px;
  padding-bottom: 4px;
`;

const UI_IconGroup_Items = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 4px;
`;

const UI_Item = styled.div`
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  &:hover {
    background-color: #e0e0e0;
    color: white;
  }
`;